import React from 'react';
import type { BombiixCellRendererParams } from '../../../../../../../Components/BombiixAGGrid/types';
import type { MeasurementGridRow } from '../grid-types';

/**
 * Product Number, shown on the product's first row only. Read-only: the Push copy source is chosen by
 * ticking the row checkbox, not by clicking the number.
 */
const ProductNumberCell: React.FC<BombiixCellRendererParams<MeasurementGridRow>> = ({ data }) => {
  if (!data?.isFirstOfProduct) return null;
  return <span className="bulk-measure-product-number">{data.number || '—'}</span>;
};

export default ProductNumberCell;
